import { ServiceType } from "./models/service/servicetype.model";
import { Injectable } from "@angular/core";

@Injectable()
export class SimTypeService{
  constructor(){
    
  }
  getListSimType():ServiceType[]{
    let typeList:ServiceType[]=[];
    typeList.push( new ServiceType(1, 'Viettel KPP'));
    typeList.push( new ServiceType(2, 'Vina SMCS'));
    return typeList;
  }
}
